module.exports = __webpack_public_path__ + "media/northern_lights_v7.011ef276.webm";